export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const trackCatalogueEvent = (eventName, eventData = {}) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    });
  }
};

export const trackCatalogueView = (componentText, day, auctionName) => {
  const eventName = 'auction-catalogue-view';
  trackCatalogueEvent(eventName, {
    componentText,
    day,
    action: 'View',
    auctionName,
  });
};

export const trackCatalogueDownload = (componentText, day, auctionName) => {
  const eventName = 'auction-catalogue-download';
  trackCatalogueEvent(eventName, {
    componentText,
    day,
    action: 'Download',
    auctionName,
  });
};

export const detectAndTrackCatalogueEvent = (buttonText, auctionName) => {
  const lowerButtonText = buttonText.toLowerCase();

  const foundWeekday = WEEKDAYS.find(weekday =>
    lowerButtonText.includes(weekday)
  );

  const hasCatalogue = lowerButtonText.includes('catalogue');

  if (!foundWeekday || !hasCatalogue) {
    return;
  }

  if (
    lowerButtonText.includes('view') &&
    !lowerButtonText.includes('download')
  ) {
    trackCatalogueView(lowerButtonText, foundWeekday, auctionName);
  } else if (
    lowerButtonText.includes('download') &&
    !lowerButtonText.includes('view')
  ) {
    trackCatalogueDownload(lowerButtonText, foundWeekday, auctionName);
  }
};

export const setupCatalogueLinkTracking = (containerRef, auctionName) => {
  if (!containerRef.current) return;

  const addCatalogueLinkTracking = () => {
    const links = containerRef.current.querySelectorAll('a');

    links.forEach(link => {
      const linkText = link.textContent.toLowerCase();

      const parentParagraph = link.closest('p');
      if (parentParagraph) {
        const paragraphText = parentParagraph.textContent.toLowerCase();

        const foundWeekday = WEEKDAYS.find(weekday =>
          paragraphText.includes(weekday)
        );

        const hasCatalogue = paragraphText.includes('catalogue');

        if (foundWeekday && hasCatalogue) {
          const handleClick = e => {
            if (linkText.includes('view') && !linkText.includes('download')) {
              const catalogueSectionText = `${foundWeekday} catalogue: view or download`;
              trackCatalogueView(
                catalogueSectionText,
                foundWeekday,
                auctionName
              );
            } else if (
              linkText.includes('download') &&
              !linkText.includes('view')
            ) {
              const catalogueSectionText = `${foundWeekday} catalogue: view or download`;
              trackCatalogueDownload(
                catalogueSectionText,
                foundWeekday,
                auctionName
              );
            }
          };

          link.removeEventListener('click', handleClick);
          link.addEventListener('click', handleClick);
        }
      }
    });
  };

  const timeoutId = setTimeout(addCatalogueLinkTracking, 100);

  return () => {
    clearTimeout(timeoutId);
  };
};
